<template>
  <ModalDialog
    v-model="visible"
    :title="$localize('BusinessUserDeleteModalTitle')"
    :is-danger="true"
    :is-wide="false"
  >
    <template #default>
      <div class="text-pre-wrap">
        {{ $localize(isAuthenticatedUserSelected ? 'BusinessUserSelfDeleteModalMessage' : 'BusinessUserDeleteModalMessage') }}
      </div>
      <br>
      <div>
        {{ $localize('BusinessUserModalQuestion') }}
      </div>
    </template>
    <template #footer>
      <button
        ref="closeBtn"
        class="btn btn-outline-secondary"
        @click="visible = false"
      >
        {{ $localize('Cancel') }}
      </button>
      <button
        ref="deleteBtn"
        class="btn btn-danger"
        data-test="ConfirmDelete"
        @click="emit('delete')"
      >
        {{ $localize('Continue') }}
      </button>
    </template>
  </ModalDialog>
</template>

<script setup lang="ts">
  import ModalDialog from '@/VueComponents/Modals/ModalDialog.vue';
  defineProps<{
    isAuthenticatedUserSelected: boolean
  }>();
  const emit = defineEmits < { 'delete' }>();
  const visible = defineModel<boolean>({ default: false });

</script>
